import { useCallback, useState } from 'react';
import { MdApps } from 'react-icons/md';
import { Popover } from 'react-tiny-popover';
import NavBarMenuContent from '../NavBarMenuContent/NavBarMenuContent';
import styles from './NavBarMenu.module.scss';

const NavBarMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsOpen(true);
  };

  const handleCloseMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Popover isOpen={isOpen} positions={['bottom', 'right']} content={<NavBarMenuContent handleCloseMenu={handleCloseMenu} />} onClickOutside={handleCloseMenu}>
      <button type="button" className={styles['navbar-menu']} onClick={handleOpenMenu}>
        <MdApps size={24} />
      </button>
    </Popover>
  );
};

export default NavBarMenu;
